import { render, staticRenderFns } from "./list_madatory.vue?vue&type=template&id=43b38ca1&"
import script from "./list_madatory.vue?vue&type=script&lang=js&"
export * from "./list_madatory.vue?vue&type=script&lang=js&"
import style0 from "./list_madatory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports